import React, { useEffect, useState } from "react";
import { deleteAIServer } from "../../services/serverRuleService.js";
import { toast } from "react-toastify";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Grid, Pagination, CircularProgress } from "@mui/material";
import MouseClickList from "../MouseClickList.tsx";
import { useNavigate } from "react-router-dom";

export default function ServerManageTable({ serverList, setRefresh, loading, setCount, total, currentPage, setPage }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedServerId, setSelectedServerId] = useState(null);
  const navigate = useNavigate();
  const columns = [
    { field: "id", headerName: "No.", width: 50 },
    {
      field: "serverAddress",
      headerName: "Address",
      width: 200,
    },
    {
      field: "identifier",
      headerName: "Identifier",
      width: 100,
    },
    {
      field: "gpu",
      headerName: "GPU",
      width: 150,
    },
    {
      field: "tag",
      headerName: "Tag",
      width: 100,
    },
    {
      field: "create_at",
      headerName: "Date",
      width: 160,
    },
  ];

  const handleEdit = async (row) => {
    navigate(`/server-manage/${selectedServerId}`);
  };

  const handleDelete = async (row) => {
    try {
      const confirm = window.confirm("정말로 해당 서버를 삭제하시겠습니까?");
      if (!confirm) return;
      await deleteAIServer(selectedServerId);
      toast.success("서버가 삭제되었습니다.");
      setRefresh(true);
      handleClose();
    } catch (error) {
      console.error("Error deleting server:", error);
    }
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
    const selectedServerId = event.currentTarget.getAttribute("data-id");
    setAnchorEl(event.currentTarget);
    setOpen(true);
    setSelectedServerId(Number(selectedServerId));
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  return (
    <>
      {loading ? (
        <CircularProgress />
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Grid container sx={{ mt: 3 }}>
            <DataGrid
              hideFooter
              hideFooterPagination
              disableColumnMenu
              disableColumnSorting
              rows={serverList}
              columns={columns}
              getRowId={(row) => row.id}
              slotProps={{
                row: {
                  onContextMenu: handleContextMenu,
                  style: { cursor: "context-menu" },
                },
              }}
              // onRowClick={handleDetailClick}
              sx={{
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "var(--dg-table-header-bg-color)",
                  color: "#fff",
                },
                "& .MuiDataGrid-filler": {
                  backgroundColor: "var(--dg-table-header-bg-color)",
                  color: "#fff",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bold",
                },
                "& .MuiDataGrid-virtualScrollerContent": {
                  backgroundColor: "white",
                },
                "& .MuiDataGrid-cell": {
                  cursor: "pointer",
                  backgroundColor: "var(--unselected-row-bg)",
                  color: "var(--dg-color)",
                },
              }}
            />

            <MouseClickList
              anchorEl={anchorEl}
              open={open}
              category="insp_rule"
              // existModuleIds={existModuleIds}
              onClose={handleClose}
              onEdit={handleEdit}
              onDelete={handleDelete}
              // onModuleDelete={handleModuleDelete}
            />
            {/* {isModalOpen && (
                      <TrainModal
                        open={isModalOpen}
                        onClose={handleCloseModal}
                        state={state}
                        selectTrain={selectedTrain}
                      />
                    )} */}
          </Grid>
          <Pagination
            count={Math.ceil(total / 10)}
            page={currentPage}
            onChange={(_, value) => setPage(value)}
            color="primary"
            size="medium"
            sx={{ mt: 2, display: "flex", justifyContent: "center" }}
          />
        </Box>
      )}
    </>
  );
}
